<template>
  <InputGroup appearance="price-group">
    <NumberInput
      v-model="priceModel"
      :placeholder="placeholder"
      :disabled="disabled"
      v-on="listeners"
    />
    <component
      :is="dropdown ? 'DropdownSelect' : 'BasicSelect'"
      :options="currencyOptions"
      :disabled="disabled"
      no-auto-size
      v-model="currencyModel"
    />
  </InputGroup>
</template>

<script>
  import { createPropModel } from 'src/utils/vue.js';

  import BasicSelect from 'src/components/form/BasicSelect/BasicSelect.vue';
  import DropdownSelect from 'src/components/form/DropdownSelect/DropdownSelect.vue';
  import InputGroup from 'src/components/form/InputGroup/InputGroup.vue';
  import NumberInput from 'src/components/form/NumberInput/NumberInput.vue';

  export default {
    name: 'PriceInputGroup',
    components: { InputGroup, BasicSelect, NumberInput, DropdownSelect },
    props: {
      value: Number,
      currency: String,
      currencyOptions: {
        type: Array,
        required: true,
      },
      placeholder: String,
      dropdown: Boolean,
      disabled: Boolean,
    },
    computed: {
      priceModel: createPropModel(),
      currencyModel: createPropModel('currency'),
      listeners() {
        const { input, ...rest } = this.$listeners;
        
        return rest;
      },
    },
  }
</script>